import React from "react";

export function Waves() {
    return (
        <>
            <svg className="waves" viewBox="0 0 1440 120" preserveAspectRatio="none" fill="#242933" style={{ backgroundColor: "#2E3440" }}>
                <path d="M1440 21.21V120H0V21.21C120 35.07 240 42 360 42s240-6.93 360-20.79c88.328-8.794 154.574-14.333 198.738-16.618A3120.562 3120.562 0 0 1 1080 .42c120 0 240 6.93 360 20.79z"></path>
            </svg>
            <div style={{ backgroundColor: "#242933", width: "100%", height: "50%" }} />
            <svg className="waves" viewBox="0 0 1920 157.327" preserveAspectRatio="none" fill="#2E3440" style={{ backgroundColor: "#242933" }}>
                <path d="M303.719 110.734a3330.42 3330.42 0 0 0 168.09 4.234 3320.491 3320.491 0 0 0 159.313-3.813c135.609-6.535 268.979-21.525 396.41-44.547C1296.81 17.949 1525.27 3.983 1669.51.833c151.12-3.304 243.74 4.253 250.49 4.822v151.672H0v-77.97c12.939 2.334 128.5 22.508 303.719 31.377z"></path>
            </svg>
        </>
    );
}